import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { EventTileGroup } from 'components/UI/EventTileGroup/EventTileGroup';
import { EventTile } from 'components/UI/EventTile/EventTile';
import { Link } from 'components/UI/Link/Link';
import { Loading } from 'components/UI/Loading/Loading';
import { hasFeatureEvent } from 'utils';
import { endpoints } from 'utils/global-constants';

import './FeaturedEvents.scss';

export const FeaturedEvents = (props) => {
  const {
    sectionTitle = '',
    stillLookingEvents,
    hasNoBackground = false,
    filterApiUrl = endpoints.getFeaturedEvents,
    collapseOnMobile,
    extendClass,
  } = props;
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchEvents = async () => {
    try {
      const response = await axios.get(filterApiUrl);
      const formattedEvents = response?.data?.events;
      setEvents(formattedEvents);
      setIsLoading(false);
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const featuredEventsContent = (
    <div className="featured-events__container container" data-testid="featured-events">
      <h2 className="featured-events__heading h3">{sectionTitle}</h2>
      <EventTileGroup hasFeaturedTile={hasFeatureEvent(events)} collapseOnMobile={collapseOnMobile}>
        {events?.map((event, index) => (
          <EventTile {...event} key={index} collapseOnMobile={collapseOnMobile} />
        ))}
      </EventTileGroup>
      {stillLookingEvents?.length && (
        <div className="featured-events__links" data-testid="still-looking-links">
          <strong>Still looking?</strong>
          <ul>
            {stillLookingEvents.map((sectionLink, index) => (
              <li key={index} data-testid="section-link">
                <Link
                  extendClass="featured-events__link"
                  variant="secondary"
                  href={sectionLink?.key}
                >
                  {sectionLink?.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );

  const classes = [
    'featured-events',
    isLoading ? 'featured-events--is-loading' : '',
    hasNoBackground ? 'no-bg' : 'spire-bg spire-opaque',
    extendClass,
  ].join(' ');

  return (
    <section className={classes} data-testid="featured-events">
      {isLoading ? <Loading /> : featuredEventsContent}
    </section>
  );
};

FeaturedEvents.propTypes = {
  sectionTitle: PropTypes.string,
  stillLookingEvents: PropTypes.arrayOf(PropTypes.object),
  hasNoBackground: PropTypes.bool,
  filterApiUrl: PropTypes.string,
  collapseOnMobile: PropTypes.bool,
  extendClass: PropTypes.string,
};

export const FeaturedEventsSC = (props) => {
  const { sitecoreData } = props;
  return <FeaturedEvents {...sitecoreData} />;
};

FeaturedEventsSC.propTypes = {
  sitecoreData: PropTypes.object,
};
